<template>
  <div class="loading-screen">
    <div class="loading-container">
      <ProgressBar
        :value="value"
      />
      <p class="loading-sent">
        {{ pickedSentance }}
      </p>
    </div>
    <div>
      <img
        class="loading-logo" 
        :src="`/static/img/${logoSvg}`"
      />
      <p>
        {{ appVersion }}
      </p>

    </div>
  </div>
</template>

<script>
import ProgressBar from 'primevue/progressbar';
import './Loading.scss'

export default {
  data() {
    return {
      value: 0,
      appVersion: process.env.VUE_APP_VERSION,
      sentances: [
        "טוען את הדיבור השוטף שלך",
        "מארגן את חוקי הדקדוק",
      ],
      pickedSentance: "טוען את הדיבור השוטף שלך",
      logoSvg: localStorage.getItem("logoSvg"),
    }
  },
  props: ["loadingValue"],
  beforeDestroy() {
    setTimeout(() => { this.value = 100 }, 1000);
  },
  components: { ProgressBar },
  methods: {
    getRandomSentance() {
      this.pickedSentance = this.sentances[Math.random(0, this.sentances.length - 1)]
    },
  },
  watch: {
    loadingValue() {
      this.value = this.loadingValue
    },
  }
}
</script>


// WEBPACK FOOTER //
// Loading.vue?d29b8ba4